import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTABanner() {
  return (
    <section className="bg-[#0A0A0A] clip-diagonal-top relative overflow-hidden">
      <div className="absolute inset-y-0 right-0 w-1/3 bg-[#E4001C]/10 clip-chevron-right" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24 md:py-32 relative">
        <p className="font-tech font-semibold uppercase tracking-[0.2em] text-[#FF4D5E] text-sm mb-4">Ready to Specify?</p>
        <h2 className="font-heading font-extrabold uppercase text-4xl md:text-6xl text-white tracking-wide mb-6">
          Get a Custom Quote
        </h2>
        <p className="text-[#A8ADB4] max-w-xl mb-10 leading-relaxed">
          Send us your project details and our engineering team will prepare a tailored
          expansion joint solution with full specifications and pricing.
        </p>
        <Link to="/contact"
          className="inline-flex items-center gap-3 bg-[#E4001C] hover:bg-[#c00018] text-white font-tech font-semibold uppercase tracking-widest px-8 py-4 transition-all hover:gap-5">
          Request a Quote <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}